/**
 * Firebase認証エラーを日本語メッセージに変換する関数
 * @param {Object} error - Firebaseエラーオブジェクト
 * @returns {string} 日本語エラーメッセージ
 */
export const getFirebaseErrorMessage = (error) => {
  const errorCode = error.code;
  
  switch (errorCode) {
    case 'auth/email-already-in-use':
      return 'このメールアドレスは既に使用されています。';
    
    case 'auth/invalid-email':
      return 'メールアドレスの形式が正しくありません。';
    
    case 'auth/operation-not-allowed':
      return 'この操作は許可されていません。管理者にお問い合わせください。';
    
    case 'auth/weak-password':
      return 'パスワードが弱すぎます。6文字以上で設定してください。';
    
    case 'auth/user-disabled':
      return 'このアカウントは無効化されています。';
    
    case 'auth/user-not-found':
      return 'このメールアドレスは登録されていません。';
    
    case 'auth/wrong-password':
      return 'パスワードが間違っています。';
    
    case 'auth/invalid-credential':
      return 'メールアドレスまたはパスワードが間違っています。';
    
    case 'auth/too-many-requests':
      return 'しばらく時間をおいてから再度お試しください。';
    
    case 'auth/network-request-failed':
      return 'ネットワークエラーが発生しました。インターネット接続を確認してください。';
    
    case 'auth/requires-recent-login':
      return 'この操作を行うには再度ログインが必要です。';
    
    case 'auth/invalid-verification-code':
      return '確認コードが正しくありません。';
    
    case 'auth/invalid-verification-id':
      return '確認IDが正しくありません。';
    
    case 'auth/expired-action-code':
      return '確認コードの有効期限が切れています。';
    
    case 'auth/invalid-action-code':
      return '確認コードが無効です。';
    
    case 'auth/popup-closed-by-user':
      return 'ポップアップが閉じられました。再度お試しください。';
    
    case 'auth/popup-blocked':
      return 'ポップアップがブロックされました。ブラウザの設定を確認してください。';
    
    case 'auth/cancelled-popup-request':
      return 'ポップアップリクエストがキャンセルされました。';
    
    case 'auth/account-exists-with-different-credential':
      return 'このメールアドレスは別の認証方法で既に登録されています。';
    
    case 'auth/credential-already-in-use':
      return 'この認証情報は既に別のアカウントで使用されています。';
    
    case 'auth/email-change-needs-verification':
      return 'メールアドレスの変更には確認が必要です。';
    
    case 'auth/internal-error':
      return '内部エラーが発生しました。しばらく時間をおいてから再度お試しください。';
    
    case 'auth/invalid-api-key':
      return 'APIキーが無効です。管理者にお問い合わせください。';
    
    case 'auth/invalid-user-token':
      return 'ユーザートークンが無効です。再度ログインしてください。';
    
    case 'auth/missing-email':
      return 'メールアドレスが入力されていません。';
    
    case 'auth/missing-password':
      return 'パスワードが入力されていません。';
    
    case 'auth/quota-exceeded':
      return 'リクエスト数の上限を超えました。しばらく時間をおいてから再度お試しください。';
    
    case 'auth/unauthorized-domain':
      return '許可されていないドメインです。';
    
    case 'auth/user-token-expired':
      return 'ユーザートークンの有効期限が切れています。再度ログインしてください。';
    
    default:
      // デフォルトメッセージ（エラーコードが不明な場合）
      console.warn('未対応のFirebaseエラーコード:', errorCode);
      return error.message || 'エラーが発生しました。しばらく時間をおいてから再度お試しください。';
  }
}; 